<template>
    <div class="pds-page-wrapper">
        <slot />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@use '@pds/style/variables/variables' as pds;

.pds-page-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 80px;
    height: 100%;
    padding: 0 pds.$pds-spacing-40;
    overflow-y: auto;
    background-color: pds.$pds-color-alias-background-primary;
}
</style>
